// "Development" enabled environment

export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.development.json',
    grafana: {
        isEnabled: false,
        url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/e2fcacd81f575cb4236ac1420982faa0',
        environmentName: 'development',
        allowUrl: "https://fixedassets-backend-dev.upmuruguay.net"
    }
};
